module.exports = __webpack_public_path__ + "img/img6.dc543f85.png";